export default "__VITE_ASSET__DdRKv$YJ__"